























































import { ClientAccountsApi } from '@/api/client-accounts';
import editDeedDialog from '@/components/client/view-client/edit-deed-dialog.vue';
import { ClientAccount } from '@/shared/clients/client-account';
import { ClientAccountDeed } from '@/shared/clients/client-account-deed';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const clientApi = new ClientAccountsApi();

const userModule = namespace('user');

@Component({
    components: {
        editDeedDialog,
    },
})
export default class ClientDeedDetails extends Vue {
    @userModule.Getter('isAdministrator') public isAdministrator!: boolean;
    @userModule.Getter('isCustomerExperienceExecutiveTeamLeader') public isCustomerExperienceExecutiveTeamLeader!: boolean;
    @userModule.Getter('isDataCreationTeamLeader') public isDataCreationTeamLeader!: boolean;

    @Prop({ required: true }) public client!: ClientAccount;

    private editDeedDialogVisible: boolean = false;
    private deleteDeedConfirmationDialogVisible: boolean = false;
    private selectedDeed: ClientAccountDeed | null = null;

    private get canDelete(): boolean {
        return this.isAdministrator || this.isCustomerExperienceExecutiveTeamLeader || this.isDataCreationTeamLeader;
    }
    private showEditDeedDialog(deed: ClientAccountDeed): void {
        if (deed.id == null) {
            deed.id = 'editing';
        }

        this.selectedDeed = { ...deed };
        this.editDeedDialogVisible = true;
    }
    private showDeleteDeedDialog(deed: ClientAccountDeed): void {
        if (deed.id == null) {
            deed.id = 'editing';
        }

        this.selectedDeed = { ...deed };
        this.deleteDeedConfirmationDialogVisible = true;
    }
    private onDeedUpdated(deed: ClientAccountDeed): void {
        const index = this.client!.deeds.findIndex((d) => d.id === deed.id);

        if (index < 0) {
            return;
        }

        if (deed.id === 'editing') {
            deed.id = null;
        }

        // Note(Seb): Setting executors[index] doesn't trigger the deep watcher on the client object
        this.client!.deeds.splice(index, 1, deed);
        this.onCancel();
        this.$emit('deed-updated', deed);
    }
    private async onDelete(): Promise<void> {
        const index = this.client!.deeds.findIndex((d) => d.id === this.selectedDeed!.id);

        if (index < 0) {
            return;
        }

        if (this.selectedDeed!.id === 'editing') {
            this.selectedDeed!.id = null;
        }

        this.client!.deeds.splice(index, 1);
        this.$emit('deed-deleted', { ...this.selectedDeed! });
        this.onCancel();
    }
    private onCancel(): void {
        for (const deed of this.client!.deeds.filter((d) => d.id === 'editing')) {
            deed.id = null;
        }

        this.selectedDeed = null;
        this.editDeedDialogVisible = false;
        this.deleteDeedConfirmationDialogVisible = false;
    }
}
